export { default as ExposedSidesLayout } from "./exposed_sides_layout";
